module.exports = __webpack_public_path__ + "img/isa7.9fa42bdb.png";